import React, { useState } from 'react'
import ContentSection from '../../Content'
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import separateNumber from '../../../utils/separateur';
import BaseUrl from '../../../utils/BaseUrl';

const url = BaseUrl();
const InfoDemandeAsset = () => {
    const location = useLocation();
    const rowData = location.state?.rowData;
     const [urlImg,setUrlImg] = useState();


    const open_modal_rejet_affect=()=>{
        window.$("#exampleModalCenter").modal('show');
    }
  return (
     <ContentSection ulShownav={"gest-affectations"} navactive={"demandeasset"}>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-12">
                        
                        <div class="mb-5">
                            <h3 class="mb-0 ">Information de la demande <b className='text-success'>{rowData.demande.reference}</b> </h3>
                        </div>
                    </div>

                    <div class="row">
                        <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <div class="card mb-4 mt-4 mt-xxl-0">
                                    <div class="card-header">
                                        <h4 class="mb-3">Detail de la demande</h4>
                                        <div class="card-body bg-light">
                                            <ul class="list-unstyled mb-0">
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Code :</span>
                                                    <span>{rowData.demande.reference}</span>
                                                </li>
                                                 <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Date de création : </span>
                                                    <span>{rowData.demande.date ? moment(rowData.demande.date).format('Do MMMM yy HH:mm') : ""}</span>

                                                </li>

                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Statut actuelle : </span>
                                                                  {rowData.demande.status == 'En cours' && <span class="badge bg-warning">{rowData.demande.status}</span>}
                                                                    {rowData.demande.status == 'Validé' && <span class="badge bg-success">{rowData.demande.status}</span>}                                                        
                                                                    {rowData.demande.status == 'Réfusé' && <span class="badge bg-danger">{rowData.demande.status}</span>}                                                         

                                                </li>

                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Demandeur : </span>
                                                    <span > {rowData.demande.addby.roles[0].name} | {rowData?.demande?.addby.use_nom} {rowData?.demande?.addby?.use_prenom} ( {rowData.demande?.addby?.phone} )</span>

                                                </li>
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Catégorie demandée :</span>
                                                    <span>{rowData.demande.categorie.libelle}</span>
                                                </li>
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Asset demande :</span>
                                                    <span>{rowData.demande?.article?.libelle}</span>
                                                </li>

                                                 <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Capacité Asset demande :</span>
                                                    <span>{rowData.demande?.article?.capacite?.libelle}</span>
                                                </li>
                                            </ul>
                                            <b><u>Description</u></b><br/>
                                            <span className="card p-2">{rowData.demande.description}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="card mb-4 mt-4 mt-xxl-0">
                                    <div class="card-header">
                                        <h4 class="mb-3">Autoriser par</h4>
                                        <div class="card-body bg-light">
                                            <ul class="list-unstyled mb-0">
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Nom :</span>
                                                    <span>{rowData.auteur.use_nom} {rowData.auteur.use_prenom}</span>
                                                </li>
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Fonction :</span>
                                                    <span>{rowData.auteur.roles[0].name}</span>
                                                </li>
                                                 <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Contact :</span>
                                                    <span>{rowData.auteur.phone}</span>
                                                </li>
                                                 <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Date : </span>
                                                    <span>{rowData.demande.date ? moment(rowData.created_at).format('Do MMMM yy HH:mm') : ""}</span>
                                                </li>

                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Statut  : </span>
                                                                  {rowData.status == 'En cours' && <span class="badge bg-warning">{rowData.status}</span>}
                                                                    {rowData.status == 'Validé' && <span class="badge bg-success">{rowData.status}</span>}                                                        
                                                                    {rowData.status == 'Réfusé' && <span class="badge bg-danger">{rowData.status}</span>}                                                         

                                                </li>
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Commentaire :</span>
                                                    <span>{rowData.commentaire}</span>
                                                </li>

                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Niveau de la demande : </span>
                                                    <span className='text-danger'> {rowData.step}</span>

                                                </li>
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Niveau suivant :</span>
                                                    {rowData.step_next==2 && <span>CONFIRMATION TM</span>}
                                                    {rowData.step_next==3 && <span>APPROBATION ASM</span>}
                                                    {rowData.step_next==4 && <span>APPROBATION RSM</span>}
                                                    {rowData.step_next==5 && <span>VALIDATION TMC</span>}
                                                    {rowData.step_next==6 && <span>EDITION CONTRAT TM</span>}
                                                    {rowData.step_next==7 && <span>EMISSION CONTRAT TM</span>}
                                                    {rowData.step_next==8 && <span>PREPARATION DE TOURNEE TMC</span>}
                                                    {rowData.step_next==9 && <span>LIVRAISON COMMERCIAL</span>}
                                                    {rowData.step_next==10 && <span>CLOTURE TMC</span>}
                        
                                                </li>
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Statut niveau suivant :</span>
                                                       {rowData.status_next == 'En cours' && <span class="badge bg-warning">{rowData.status_next}</span>}
                                                        {rowData.status_next == 'Validé' && <span class="badge bg-success">{rowData.status_next}</span>}                                                        
                                                        {rowData.status_next == 'Réfusé' && <span class="badge bg-danger">{rowData.status_next}</span>}  
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>

                                 <div class="card mb-4 mt-4 mt-xxl-0">
                                    <div class="card-header">
                                        <h4 class="mb-3">Information PDV</h4>
                                        <div class="card-body bg-light">
                                            <ul class="list-unstyled mb-0">
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Nom :</span>
                                                    <span>{rowData.demande.d_pdv}</span>
                                                </li>
                                                 <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Contact : </span>
                                                    <span>{rowData.demande.d_contact}</span>

                                                </li>

                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Catégorie PDV : </span>                                                      
                                                    <span>{rowData.demande.d_pdv_categorie}</span>
                                                </li>

                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Adresse PDV : </span>                                                      
                                                    <span>{rowData.demande.d_addresse}</span>
                                                </li>

                                                 <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Interlocuteur : </span>                                                      
                                                    <span>{rowData.demande.interlocuteur} | {rowData.demande.contact}</span>
                                                </li>

                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Chiffre d'affaire moyen : </span>                                                      
                                                    <span className='text-danger'>{separateNumber(rowData.demande.caMoyen)}</span>
                                                </li>
                                                <li class="d-flex justify-content-between mb-3 fw-bold">
                                                    <span>Superficie: </span>                                                      
                                                    <span className='text-success'>{rowData.demande.superficie} m²</span>
                                                </li>

                                                <div>
                                                    <a onClick={()=>{setUrlImg(`${url.image}/${rowData?.demande.pdv_onephoto}`);window.$('#exampleModalCente').modal('show')}}><img src={`${url.image}/${rowData?.demande.pdv_onephoto}`} alt="" class="rounded-3 ms-3 me-2" width="30%" height="150%" /></a>
                                                    <a onClick={()=>{setUrlImg(`${url.image}/${rowData?.demande.pdv_twophoto}`);window.$('#exampleModalCente').modal('show')}}><img src={`${url.image}/${rowData?.demande.pdv_twophoto}`} alt="" class=" rounded-3"  width="30%" height="150%" /></a>
                                                </div>

                                         
                                            </ul>
                                            
                                        </div>
                                    </div>
                                </div>

                                
                            </div>
                        <div className="col-md-2"></div>
                    </div>
                </div>
            </div>

{/* MODAL */}
            <div class="modal fade" id="exampleModalCente" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">IMAGES</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <img src={urlImg} alt="" class="rounded-3 ms-3 me-2" width="100%" height="150%" />
                        </div>
                    </div>
                    {/* <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                    </div> */}
                </div>
                </div>
            </div>
     </ContentSection>
  )
}

export default InfoDemandeAsset